import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
   const [isAuthenticated, setIsAuthenticated] = useState(false);
   const [user, setUser] = useState(null);

   useEffect(() => {
      const token = localStorage.getItem('authTokenCustomer');
      if (token) {
         try {
            const decodedToken = jwtDecode(token);
            setUser(decodedToken);
            setIsAuthenticated(true);
         } catch (error) {
            // console.error('Invalid token', error);
            localStorage.removeItem('authTokenCustomer');
            setIsAuthenticated(false);
         }
      }
   }, []);

   const login = (token) => {
      localStorage.setItem('authTokenCustomer', token);
      const decodedToken = jwtDecode(token);
      setUser(decodedToken);
      setIsAuthenticated(true);
   };

   const logout = () => {
      localStorage.removeItem('authTokenCustomer');
      setUser(null);
      setIsAuthenticated(false);
   };

   return <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>{children}</AuthContext.Provider>;
};
